import { useQueries } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface QueryOptions {
  staleTime?: number
  cacheTime?: number
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
  onSettled?: () => void
}

const fetchById = async (endpoint: string, id: string) => {
  const { data } = await axios.get(`${baseUrl}${endpoint}/${id}`)
  return data
}

export const useGetQueryByIds = (
  endpoint: string,
  tableName: string,
  ids: string[] = [],
  queryKey: string,
  options: QueryOptions = {}
) => {
  // console.log('endpoint, tableName, ids = [], queryKey, options = {}', endpoint, tableName, ids, queryKey, options)
  // Ensure ids is an array
  const validIds = Array.isArray(ids) ? ids.filter(id => !!id) : []
  // console.log('[useGetQueryByIds] Valid IDs:', validIds) // This should show only valid IDs

  // Generate query configurations for useQueries
  const queries = validIds.map((id, index) => ({
    queryKey: [`${queryKey}-${index}`, id],
    queryFn: () => fetchById(endpoint, id),
    enabled: !!id, // Ensure the query only runs if the ID is valid
    staleTime: options.staleTime || Infinity, // Default to Infinity if not provided
    gcTime: options.cacheTime || 1000 * 60 * 10, // Default to 10 minutes if not provided
    onSuccess: options.onSuccess || (data => console.log('Query success:', [endpoint, id], data)),
    onError: options.onError || (error => console.error('Query error:', [endpoint, id], error)),
    onSettled: options.onSettled || (() => console.log('Query settled:', [endpoint, id])),
  }))
  return useQueries({ queries })
}
